/* LEET UI 2026 */
(function () {
  'use strict';
  var Q = function (s, r) { return (r || document).querySelector(s); };
  var QA = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var once = function (el, k) { if (!el || el['_lt' + k]) return false; el['_lt' + k] = 1; return true; };

  /* ---------- sliders (track + arrows + dots) ---------- */
  function slider(root) {
    if (!once(root, 'sl')) return;
    var trk = Q('[data-trk]', root);
    if (!trk) return;
    var dots = Q('[data-dots]', root);
    var step = function () {
      var c = Array.prototype.filter.call(trk.children, function (x) { return x.offsetWidth > 0; })[0];
      if (!c) return trk.clientWidth;
      var cs = getComputedStyle(trk);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return c.getBoundingClientRect().width + gap;
    };
    var pages = function () { var s = step(); return Math.max(1, Math.round((trk.scrollWidth - trk.clientWidth) / s) + 1); };
    var idx = function () { return Math.round(trk.scrollLeft / step()); };
    var go = function (i) {
      var n = pages();
      if (i < 0) i = n - 1;
      if (i >= n) i = 0;
      trk.scrollTo({ left: i * step(), behavior: 'smooth' });
    };
    var draw = function () {
      if (!dots) return;
      var n = pages(), a = idx();
      if (dots.children.length !== n) {
        dots.innerHTML = '';
        for (var i = 0; i < n; i++) dots.appendChild(document.createElement('i'));
      }
      QA('i', dots).forEach(function (d, i) { d.className = i === a ? 'on' : ''; });
      dots.style.display = n > 1 ? '' : 'none';
    };
    var one = function () { root.classList.toggle('lt-one', pages() <= 1); };
    var fit = function () {
      if (!root.hasAttribute('data-fit')) return;
      var wrap = getComputedStyle(trk).flexWrap === 'wrap';
      var c = trk.children[Math.min(idx(), trk.children.length - 1)];
      if (wrap || !c || pages() <= 1) { trk.style.height = ''; trk.classList.remove('lt-fit'); return; }
      var cs = getComputedStyle(c);
      trk.classList.add('lt-fit');
      trk.style.height = Math.ceil(c.getBoundingClientRect().height + (parseFloat(cs.marginTop) || 0) + (parseFloat(cs.marginBottom) || 0)) + 'px';
    };
    if (root.hasAttribute('data-fit')) {
      root.addEventListener('lt:slide', fit);
      trk.addEventListener('load', function () { fit(); }, true);
      window.addEventListener('resize', fit);
      setTimeout(fit, 50);
    }
    QA('[data-prev]', root).forEach(function (b) { b.addEventListener('click', function () { go(idx() - 1); }); });
    QA('[data-next]', root).forEach(function (b) { b.addEventListener('click', function () { go(idx() + 1); }); });
    var t;
    trk.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { draw(); root.dispatchEvent(new CustomEvent('lt:slide', { detail: idx() })); }, 60); }, { passive: true });
    window.addEventListener('resize', function () { draw(); one(); });
    root.addEventListener('lt:slide', function () {
      var t = trk.getBoundingClientRect();
      QA('video', trk).forEach(function (v) { if (v.paused) return; var r = v.getBoundingClientRect(); if (r.right < t.left + 10 || r.left > t.right - 10) v.pause(); });
    });
    root._ltGo = go;
    draw(); one();
    if (document.readyState !== 'complete') window.addEventListener('load', function () { draw(); one(); });
  }

  /* ---------- product gallery ---------- */
  function gallery(root) {
    if (!once(root, 'gal')) return;
    var main = Q('[data-main]', root);
    if (!main) return;
    slider(main);
    var thumbs = QA('[data-th]', root);
    var thTrk = Q('[data-thtrk]', root);
    var mark = function (i) {
      thumbs.forEach(function (b, j) { b.classList.toggle('on', j === i); });
      var b = thumbs[i];
      if (b && thTrk) {
        var l = b.offsetLeft - thTrk.offsetLeft, r = l + b.offsetWidth;
        if (l < thTrk.scrollLeft || r > thTrk.scrollLeft + thTrk.clientWidth) thTrk.scrollTo({ left: l - 4, behavior: 'smooth' });
      }
    };
    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { main._ltGo(i); mark(i); }); });
    main.addEventListener('lt:slide', function (e) { mark(e.detail); });
    QA('[data-gprev]', root).forEach(function (b) { b.addEventListener('click', function () { var t = Q('[data-trk]', main); var w = t.clientWidth; main._ltGo(Math.round(t.scrollLeft / w) - 1); }); });
    QA('[data-gnext]', root).forEach(function (b) { b.addEventListener('click', function () { var t = Q('[data-trk]', main); var w = t.clientWidth; main._ltGo(Math.round(t.scrollLeft / w) + 1); }); });
  }

  /* ---------- packs: the chosen pack sets the quantity in the add-to-cart form; the pack price comes from Shopify discounts ---------- */
  function pForm(root) { return Q('form[data-type="add-to-cart-form"]', root) || Q('form[action*="/cart/add"]', root); }
  function packs(root) {
    var box = Q('[data-lt-packs]', root);
    if (!box || !once(box, 'pk')) return;
    var items = QA('[data-pk]', box);
    if (!items.length) return;
    var form = pForm(root);
    var cur = items.filter(function (p) { return p.classList.contains('sel'); })[0] || items[0];
    var param = parseInt(new URLSearchParams(location.search).get('pack'), 10);
    if (param && items[param - 1]) cur = items[param - 1];
    var setQty = function () {
      if (!form || !cur) return;
      var q = Q('input[name="quantity"]', form);
      if (!q) { q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; form.appendChild(q); }
      q.disabled = false;
      q.value = cur.getAttribute('data-q') || '1';
    };
    var apply = function () {
      items.forEach(function (p) { var on = p === cur; p.classList.toggle('sel', on); p.setAttribute('aria-checked', on ? 'true' : 'false'); p.tabIndex = on ? 0 : -1; });
      setQty();
      root.dispatchEvent(new CustomEvent('lt:pack', { detail: { index: items.indexOf(cur) + 1 } }));
    };
    var pick = function (p) { if (p && p !== cur) { cur = p; apply(); } };
    items.forEach(function (p, n) {
      p.addEventListener('click', function () { pick(p); });
      p.addEventListener('keydown', function (e) {
        var k = e.key;
        if (k === 'Enter' || k === ' ') { e.preventDefault(); pick(p); }
        else if (k === 'ArrowDown' || k === 'ArrowRight' || k === 'ArrowUp' || k === 'ArrowLeft') {
          e.preventDefault();
          var d = (k === 'ArrowDown' || k === 'ArrowRight') ? 1 : -1;
          var t = items[(n + d + items.length) % items.length];
          pick(t); t.focus();
        }
      });
    });
    if (form) form.addEventListener('submit', setQty, true);
    apply();
    root.addEventListener('lt:selectpack', function (e) { pick(items[(e.detail || 1) - 1]); });
  }

  /* ---------- offer timer: counts down to the end of the current cycle (12h = to 12:00 and to 24:00) ---------- */
  function timer(el) {
    if (!once(el, 'tm')) return;
    var b = QA('b', el);
    var cyc = Math.max(1, Math.min(24, parseFloat(el.getAttribute('data-cycle')) || 24)) * 3600;
    var tick = function () {
      var n = new Date(), m = new Date(n); m.setHours(0, 0, 0, 0);
      var gone = Math.floor((n - m) / 1000);
      var s = cyc - (gone % cyc);
      if (s > cyc) s = cyc;
      var v = [Math.floor(s / 3600), Math.floor(s % 3600 / 60), s % 60];
      b.forEach(function (x, i) { if (v[i] !== undefined) x.textContent = (v[i] < 10 ? '0' : '') + v[i]; });
    };
    tick(); setInterval(tick, 1000);
  }

  /* ---------- testimonial rotator ---------- */
  function quotes(el) {
    if (!once(el, 'qs')) return;
    var it = QA('[data-qi]', el), dots = QA('[data-qd] button', el);
    if (it.length < 2) return;
    var i = 0, ms = (parseFloat(el.getAttribute('data-int')) || 3) * 1000, t = null, hold = false;
    var show = function (n) {
      i = (n + it.length) % it.length;
      it.forEach(function (x, k) { x.classList.toggle('on', k === i); x.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    };
    var run = function () { clearInterval(t); t = setInterval(function () { if (!hold && !document.hidden) show(i + 1); }, ms); };
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); run(); }); });
    QA('[data-qp]', el).forEach(function (b) { b.addEventListener('click', function () { show(i - 1); run(); }); });
    QA('[data-qn]', el).forEach(function (b) { b.addEventListener('click', function () { show(i + 1); run(); }); });
    el.addEventListener('mouseenter', function () { hold = true; });
    el.addEventListener('mouseleave', function () { hold = false; });
    el.addEventListener('focusin', function () { hold = true; });
    el.addEventListener('focusout', function () { hold = false; });
    var x0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { show(i + (dx < 0 ? 1 : -1)); run(); } x0 = null; }, { passive: true });
    show(0); run();
  }

  /* ---------- click to play videos ---------- */
  function playables(root) {
    QA('[data-play]', root).forEach(function (btn) {
      if (!once(btn, 'pl')) return;
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-vcard]');
        var v = card && Q('video', card);
        if (!v) return;
        QA('[data-vcard] video').forEach(function (o) { if (o !== v) { o.pause(); var c = o.closest('[data-vcard]'); if (c) c.classList.remove('playing'); } });
        v.muted = false; v.controls = true; v.playsInline = true;
        var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
        card.classList.add('playing');
        v.addEventListener('pause', function () { if (v.ended) card.classList.remove('playing'); }, { once: true });
      });
    });
  }

  /* ---------- review filters ---------- */
  function filters(root) {
    var bar = Q('[data-lt-filter]', root);
    if (!bar || !once(bar, 'ft')) return;
    var btns = QA('button[data-f]', bar), cards = QA('[data-cat]', root);
    var has = function (c, f) { return (c.getAttribute('data-cat') || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).indexOf(f.toLowerCase()) > -1; };
    btns.forEach(function (b) { var f = b.getAttribute('data-f'); if (f && !cards.some(function (c) { return has(c, f); })) b.hidden = true; });
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-f');
        btns.forEach(function (x) { x.classList.toggle('on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        cards.forEach(function (c) {
          var cats = (c.getAttribute('data-cat') || '').toLowerCase().split(',').map(function (s) { return s.trim(); });
          c.hidden = !!f && cats.indexOf(f.toLowerCase()) < 0;
        });
        var sl = Q('[data-lt-slider]', root), tk = sl && Q('[data-trk]', sl);
        if (tk) { tk.scrollLeft = 0; tk.dispatchEvent(new Event('scroll')); window.dispatchEvent(new Event('resize')); }
      });
    });
  }

  /* ---------- quiz ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function quiz(root) {
    var box = Q('[data-lt-quiz]', root);
    if (!box || !once(box, 'qz')) return;
    var cfgEl = Q('script[type="application/json"]', box);
    if (!cfgEl) return;
    var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var stage = Q('[data-stage]', box);
    var qs = cfg.questions || [], ans = [], i = 0, T = cfg.texts || {};
    var CHK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
    var drawQ = function () {
      var q = qs[i], n = qs.length, pct = Math.round((i + 1) / n * 100);
      var h = '<div class="lt-qzc__top"><span>' + esc(T.q || 'Въпрос') + ' <b>' + (i + 1) + '</b> ' + esc(T.of || 'от') + ' ' + n + '</span><span>' + pct + '%</span></div>';
      h += '<div class="lt-qzc__bar"><i style="width:' + pct + '%"></i></div><h3>' + esc(q.title) + '</h3><div class="lt-qos">';
      (q.answers || []).forEach(function (a, j) {
        h += '<button type="button" class="lt-qo' + (ans[i] === j ? ' on' : '') + '" data-a="' + j + '"><i style="--qc:' + esc(a.color || '') + '">' + esc(a.emoji || '') + '</i>' + esc(a.text) + '</button>';
      });
      h += '</div><div class="lt-qzc__nav"><button type="button" class="bk"' + (i === 0 ? ' style="visibility:hidden"' : '') + ' data-back>← ' + esc(T.back || 'Назад') + '</button><button type="button" class="lt-btn lt-btn--k" data-next' + (ans[i] == null ? ' disabled' : '') + '>' + esc(i === n - 1 ? (T.finish || 'Виж резултата') : (T.next || 'Напред')) + ' →</button></div>';
      stage.innerHTML = h;
      box.classList.remove('lt-qz--done');
      QA('[data-a]', stage).forEach(function (b) {
        b.addEventListener('click', function () {
          ans[i] = parseInt(b.getAttribute('data-a'), 10);
          QA('[data-a]', stage).forEach(function (x) { x.classList.toggle('on', x === b); });
          Q('[data-next]', stage).disabled = false;
          setTimeout(next, 320);
        });
      });
      Q('[data-back]', stage).addEventListener('click', function () { if (i > 0) { i--; drawQ(); } });
      Q('[data-next]', stage).addEventListener('click', next);
    };
    var lock = false;
    var next = function () { if (lock || ans[i] == null) return; lock = true; setTimeout(function () { lock = false; }, 350); if (i < qs.length - 1) { i++; drawQ(); } else result(); };
    var result = function () {
      var score = {}, order = [], msg = '', pack = 0;
      qs.forEach(function (q, k) {
        var a = q.answers[ans[k]];
        if (!a) return;
        if (q.type === 'story' && a.msg) msg = a.msg;
        if (q.type === 'pack') pack = ans[k] + 1;
        if (q.type === 'score' && a.target && a.target !== 'none') { score[a.target] = (score[a.target] || 0) + (q.weight || 1); if (order.indexOf(a.target) < 0) order.push(a.target); }
      });
      var res = cfg.results || {}, keys = Object.keys(res);
      var best = order.sort(function (a, b) { return (score[b] || 0) - (score[a] || 0); })[0] || keys[0];
      var r = res[best] || res[keys[0]];
      if (!r) return;
      var url = r.url + (pack && r.url.indexOf('?') < 0 ? '?pack=' + pack : '');
      var h = '<div class="lt-qzc__top"><span>' + esc(T.done || 'Готово') + '</span><span>100%</span></div><div class="lt-qzc__bar"><i style="width:100%"></i></div>';
      h += '<div class="lt-qzr"><span class="lt-sk">' + esc(T.result || 'Твоят резултат') + '</span><div class="lt-qzr__p lt-pv" style="' + esc(r.vars) + '">' + (r.img ? '<img src="' + esc(r.img) + '" alt="" loading="lazy">' : '') + '<b>' + esc(r.name) + '</b></div>';
      if (r.reasons && r.reasons.length) { h += '<ul>'; r.reasons.forEach(function (x) { h += '<li><i>' + CHK + '</i><span>' + esc(x) + '</span></li>'; }); h += '</ul>'; }
      if (msg) h += '<div class="lt-qzr__m">' + esc(msg) + '</div>';
      if (pack && r.packs && r.packs[pack - 1] && r.packs[pack - 1].name) h += '<div class="lt-qzr__m"><b>' + esc(T.pack || 'Твоят пакет') + ':</b> ' + esc(r.packs[pack - 1].name) + (r.packs[pack - 1].price ? ' · <b>' + esc(r.packs[pack - 1].price) + '</b>' : '') + '</div>';
      h += '<div class="lt-qzr__b"><a class="lt-btn lt-btn--k" href="' + esc(url) + '">' + esc(r.btn || 'Виж продукта') + ' →</a><button type="button" class="lt-btn lt-btn--o lt-btn--sm" data-restart>' + esc(T.restart || 'Започни отново') + '</button></div></div>';
      stage.innerHTML = h;
      box.classList.add('lt-qz--done');
      Q('[data-restart]', stage).addEventListener('click', function () { ans = []; i = 0; drawQ(); });
    };
    if (qs.length) drawQ();
  }

  /* ---------- sticky bar ---------- */
  function sticky(el) {
    if (!once(el, 'st')) return;
    var on = function () {
      var y = window.scrollY, h = document.documentElement.scrollHeight - window.innerHeight;
      el.classList.toggle('on', y > (parseInt(el.getAttribute('data-after'), 10) || 500) && y < h - 300);
    };
    window.addEventListener('scroll', on, { passive: true }); on();
  }

  /* ---------- header ---------- */
  function header(root) {
    var hdr = Q('.lt-hdr', root);
    if (!hdr || !once(hdr, 'hd')) return;
    var ann = Q('[data-ann]', root);
    var set = function () {
      document.documentElement.style.setProperty('--lt-hh', Math.max(0, hdr.getBoundingClientRect().bottom) + 'px');
      document.documentElement.style.setProperty('--lt-annh', (ann ? ann.offsetHeight : 0) + 'px');
    };
    var m = Q('.lt-mnav', root);
    if (m) {
      m.addEventListener('toggle', function () { set(); document.documentElement.style.overflow = m.open ? 'hidden' : ''; });
      QA('a', m).forEach(function (a) { a.addEventListener('click', function () { m.open = false; }); });
    }
    window.addEventListener('resize', set); set();
    var rot = Q('[data-rot]', root);
    if (rot && once(rot, 'rot')) {
      var its = QA('.lt-ann__i', rot), k = 0, ms = (parseFloat(rot.getAttribute('data-rot')) || 5) * 1000;
      if (its.length > 1) setInterval(function () {
        if (document.hidden) return;
        var cur = its[k]; k = (k + 1) % its.length; var nx = its[k];
        cur.classList.remove('on'); cur.classList.add('out');
        nx.classList.remove('out'); nx.classList.add('on');
        setTimeout(function () { cur.classList.remove('out'); }, 520);
      }, ms);
    }
  }

  /* ---------- scroll to packs ---------- */
  function jumps(root) {
    QA('a[href="#lt-packs"],a[href="#packs"]', root).forEach(function (a) {
      if (!once(a, 'jp')) return;
      a.addEventListener('click', function (e) {
        var t = Q('[data-lt-packs]');
        if (!t) return;
        e.preventDefault();
        window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
      });
    });
  }

  /* ---------- cart → LEET intermediate checkout (/cart?view=checkout) ---------- */
  function checkoutRoute() {
    if (window._ltCoRoute) return;
    window._ltCoRoute = 1;
    if (/[?&]view=checkout\b/.test(location.search)) return;
    var url = ((window.routes && window.routes.cart_url) || '/cart') + '?view=checkout';
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('#CartDrawer-Checkout, #checkout, button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href$="/checkout"]') : null;
      if (!t || t.disabled) return;
      e.preventDefault(); e.stopImmediatePropagation();
      t.classList.add('loading');
      window.location.href = url;
    }, true);
  }

  /* ---------- promo code (cart drawer + cart page) ---------- */
  var JSONH = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var up = function (x) { return String(x || '').trim().toUpperCase(); };
  var pmsg = function (box, text, kind) {
    var m = box && Q('[data-promo-msg]', box);
    if (!m) return;
    m.textContent = text || ''; m.className = 'lt-promo__m ' + (kind || ''); m.hidden = !text;
  };
  var swapDrawer = function (cart) {
    var sec = cart && cart.sections;
    if (sec && sec['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sec['cart-drawer'], 'text/html');
      var ni = doc.querySelector('.drawer__inner'), oi = document.querySelector('cart-drawer .drawer__inner');
      if (ni && oi) { oi.innerHTML = ni.innerHTML; init(oi); }
    }
    if (sec && sec['cart-icon-bubble']) {
      var b = document.getElementById('cart-icon-bubble');
      if (b) { var d2 = new DOMParser().parseFromString(sec['cart-icon-bubble'], 'text/html'); var src = d2.querySelector('.shopify-section') || d2.body; b.innerHTML = src.innerHTML; }
    }
  };
  var promoRun = function (box, change, added) {
    var mode = box.getAttribute('data-lt-promo') || 'drawer';
    var secs = mode === 'drawer' ? ['cart-drawer', 'cart-icon-bubble'] : [];
    var post = function (codes) {
      var body = { discount: codes.join(',') };
      if (secs.length) { body.sections = secs; body.sections_url = location.pathname + location.search; }
      return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: JSONH, body: JSON.stringify(body) }).then(function (r) { if (!r.ok) throw new Error('update'); return r.json(); });
    };
    box.classList.add('is-busy'); pmsg(box, '');
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      /* the card code is added only on the checkout step, by payment; it never stays next to a promo code */
      var cc = up(window.ltCC && window.ltCC.code);
      var cur = (cart.discount_codes || []).filter(function (d) { return d.applicable && (!cc || up(d.code) !== cc); }).map(function (d) { return d.code; });
      return post(change(cur.slice()));
    }).then(function (c2) {
      if (added) {
        var f = (c2.discount_codes || []).filter(function (d) { return up(d.code) === up(added); })[0];
        if (!f || !f.applicable) {
          var keep = (c2.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
          return post(keep).then(function (c3) { return [c3, 'Кодът „' + added + '“ не важи за тази поръчка.', 'err']; });
        }
        return [c2, 'Кодът е приложен.', 'ok'];
      }
      return [c2, 'Кодът е премахнат.', 'ok'];
    }).then(function (res) {
      if (mode === 'page') {
        try { sessionStorage.setItem('lt_promo_msg', JSON.stringify([res[1], res[2]])); } catch (e) {}
        location.reload(); return;
      }
      swapDrawer(res[0]);
      var nb = document.querySelector('cart-drawer [data-lt-promo]') || box;
      nb.classList.remove('is-busy'); pmsg(nb, res[1], res[2]);
    }).catch(function () { box.classList.remove('is-busy'); pmsg(box, 'Нещо се обърка. Опитай пак.', 'err'); });
  };
  function promoInit() {
    if (window._ltPromo) return;
    window._ltPromo = 1;
    document.addEventListener('submit', function (e) {
      var f = e.target && e.target.closest ? e.target.closest('[data-promo-form]') : null;
      if (!f) return;
      e.preventDefault(); e.stopPropagation();
      var box = f.closest('[data-lt-promo]'), inp = f.querySelector('input'), code = inp ? inp.value.trim() : '';
      if (!code) { pmsg(box, 'Въведи промокод.', 'err'); if (inp) inp.focus(); return; }
      promoRun(box, function (cur) { if (cur.map(up).indexOf(up(code)) < 0) cur.push(code); return cur; }, code);
    }, true);
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-promo-rm]') : null;
      if (!b) return;
      e.preventDefault();
      var c = b.getAttribute('data-promo-rm');
      promoRun(b.closest('[data-lt-promo]'), function (cur) { return cur.filter(function (x) { return up(x) !== up(c); }); }, null);
    });
    try {
      var saved = JSON.parse(sessionStorage.getItem('lt_promo_msg') || 'null');
      if (saved) { sessionStorage.removeItem('lt_promo_msg'); var bx = Q('[data-lt-promo="page"]'); if (bx) pmsg(bx, saved[0], saved[1]); }
    } catch (e) {}
  }

  /* ---------- card code left on the cart (customer came back from Shopify checkout): take it off outside the checkout step,
     so the cart, the drawer and promo codes show the real price. The checkout step adds it again if the customer pays by card. ---------- */
  function cardStrip() {
    if (window._ltCs) return;
    window._ltCs = 1;
    var cc = window.ltCC;
    if (!cc || !cc.on || !cc.code || Q('[data-lt-co]')) return;
    var onCart = !!Q('[data-lt-cart]');
    if (onCart) {
      var last = 0;
      try { last = parseInt(sessionStorage.getItem('lt_cs') || '0', 10) || 0; } catch (e) {}
      if (Date.now() - last < 30000) return;
      try { sessionStorage.setItem('lt_cs', String(Date.now())); } catch (e) {}
    }
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var all = cart.discount_codes || [];
      var keep = all.filter(function (d) { return d.applicable && up(d.code) !== up(cc.code); }).map(function (d) { return d.code; });
      if (!all.some(function (d) { return up(d.code) === up(cc.code); })) return null;
      var body = { discount: keep.join(',') };
      var drawer = !onCart && document.querySelector('cart-drawer');
      if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = location.pathname + location.search; }
      return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: JSONH, body: JSON.stringify(body) }).then(function (r) { return r.json(); }).then(function (res) {
        cc.on = false;
        if (onCart) { location.reload(); return; }
        if (drawer) swapDrawer(res);
      });
    }).catch(function () {});
  }

  /* ---------- cart page: quantity, remove, add insurance ---------- */
  function cartPage(el) {
    if (!once(el, 'cp')) return;
    var sid = el.getAttribute('data-sec');
    var busy = false;
    var send = function (url, body) {
      if (busy) return; busy = true;
      el.classList.add('is-busy');
      body.sections = [sid, 'cart-icon-bubble']; body.sections_url = location.pathname;
      fetch(url, { method: 'POST', credentials: 'same-origin', headers: JSONH, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          var html = res && res.sections && res.sections[sid];
          if (!html) { location.reload(); return; }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-lt-cart]');
          if (fresh) { el.replaceWith(fresh); init(fresh.parentNode); giftFix(); } else location.reload();
          var bub = res.sections['cart-icon-bubble'], b = document.getElementById('cart-icon-bubble');
          if (bub && b) { var d2 = new DOMParser().parseFromString(bub, 'text/html'); var src = d2.querySelector('.shopify-section') || d2.body; b.innerHTML = src.innerHTML; }
        })
        .catch(function () { location.reload(); });
    };
    el.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-q],[data-rm],[data-add]') : null;
      if (!t) return;
      var li = t.closest('[data-key]');
      if (t.hasAttribute('data-add')) { send('/cart/add.js', { items: [{ id: parseInt(t.getAttribute('data-add'), 10), quantity: 1 }] }); return; }
      if (!li) return;
      var inp = Q('[data-qi]', li), q = parseInt(inp && inp.value, 10) || 0;
      var nq = t.hasAttribute('data-rm') ? 0 : Math.max(0, q + parseInt(t.getAttribute('data-q'), 10));
      send('/cart/change.js', { id: li.getAttribute('data-key'), quantity: nq });
    });
    el.addEventListener('change', function (e) {
      var inp = e.target; if (!inp.hasAttribute || !inp.hasAttribute('data-qi')) return;
      var li = inp.closest('[data-key]');
      send('/cart/change.js', { id: li.getAttribute('data-key'), quantity: Math.max(0, parseInt(inp.value, 10) || 0) });
    });
  }

  /* ---------- free e-book over the threshold (window.ltEB from leet-head): added once with its code, taken out again under the threshold.
     No e-book is added when the cart already has one (packs and bundles bring their own), or when the customer removed it this session. ---------- */
  var ebPlan = function (c) {
    var E = window.ltEB;
    if (!E || !E.min || !E.code || !E.books || !E.map) return null;
    var books = E.books.map(String);
    var lines = c.items || [];
    var bookLines = lines.filter(function (it) { return books.indexOf(String(it.variant_id)) > -1; });
    var base = (c.total_price || 0) - bookLines.reduce(function (a, it) { return a + (it.final_line_price || 0); }, 0);
    var auto = bookLines.filter(function (it) { return it.properties && String(it.properties._lt_gift) === '90'; });
    var flag = '';
    try { flag = sessionStorage.getItem('lt_eb') || ''; } catch (e) {}
    if (base < E.min) {
      if (flag) { try { sessionStorage.removeItem('lt_eb'); } catch (e) {} }
      return auto.length ? { remove: auto } : null;
    }
    if (bookLines.length || flag) return null;
    var best = null;
    lines.forEach(function (it) { var v = E.map[it.handle]; if (v && (!best || it.final_line_price > best.p)) best = { v: v, p: it.final_line_price }; });
    return best ? { add: best.v } : null;
  };

  /* ---------- gift lines (_lt_gift, e-books): if one is no longer free, remove it; if its quantity is above 1, set it to 1 ---------- */
  var gfBusy = false, gfT = 0;
  function giftFix() {
    if (gfBusy) return;
    gfBusy = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var upd = {}, n = 0;
        (c.items || []).forEach(function (it) {
          if (!it.properties || !it.properties._lt_gift) return;
          if (!(it.line_level_total_discount > 0)) { upd[it.key] = 0; n++; }
          else if (it.quantity > 1) { upd[it.key] = 1; n++; }
        });
        var E = window.ltEB || {};
        var plan = ebPlan(c);
        var codes = (c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        var setCodes = null;
        if (plan && plan.remove) {
          plan.remove.forEach(function (it) { if (upd[it.key] !== 0) { upd[it.key] = 0; n++; } });
          setCodes = codes.filter(function (x) { return up(x) !== up(E.code); });
        }
        if (plan && plan.add) setCodes = codes.map(up).indexOf(up(E.code)) < 0 ? codes.concat([E.code]) : codes;
        if (!n && !(plan && plan.add)) { gfBusy = false; return; }
        var now = Date.now(), log = [];
        try { log = JSON.parse(sessionStorage.getItem('lt_gf') || '[]').filter(function (t) { return now - t < 60000; }); } catch (e) {}
        if (log.length >= 3) { gfBusy = false; return; }
        log.push(now);
        try { sessionStorage.setItem('lt_gf', JSON.stringify(log)); } catch (e) {}
        var cd = document.querySelector('cart-drawer');
        var drawer = cd && typeof cd.renderContents === 'function' && !Q('[data-lt-cart],[data-lt-co]');
        var body = {};
        if (n) body.updates = upd;
        if (setCodes) body.discount = setCodes.join(',');
        if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = location.pathname; }
        var first = Promise.resolve();
        if (plan && plan.add) {
          try { sessionStorage.setItem('lt_eb', '1'); } catch (e) {}
          first = fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: JSONH, body: JSON.stringify({ items: [{ id: plan.add, quantity: 1, properties: { _lt_gift: '90' } }] }) });
        }
        return first.then(function () { return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: JSONH, body: JSON.stringify(body) }); })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (drawer && res.sections && res.sections['cart-drawer']) {
              try { cd.renderContents({ id: null, sections: res.sections }, !cd.classList.contains('active')); } catch (e) { location.reload(); }
              setTimeout(function () { gfBusy = false; }, 800);
              return;
            }
            location.reload();
          });
      })
      .catch(function () { gfBusy = false; });
  }
  function giftWatch() {
    if (window._ltGf) return;
    window._ltGf = 1;
    if (Q('[data-lt-cart],[data-lt-co]')) giftFix();
    var box = document.getElementById('CartDrawer');
    var hit = function (n) { return n.nodeType === 1 && (n.matches('.drawer__inner,cart-drawer-items,.cart-items,.cart-item') || !!n.querySelector('.cart-item')); };
    if (box) new MutationObserver(function (ms) {
      if (ms.some(function (m) { return Array.prototype.some.call(m.addedNodes, hit); })) { clearTimeout(gfT); gfT = setTimeout(giftFix, 300); }
    }).observe(box, { childList: true, subtree: true });
  }

  function ingTabs(el) {
    if (el._ltIng) return; el._ltIng = 1;
    var tabs = QA('[data-ingtab]', el), panels = QA('[data-ingpanel]', el);
    if (!tabs.length) return;
    function show(i, focus) {
      tabs.forEach(function (t, k) { var on = k === i; t.classList.toggle('on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; if (on && focus) t.focus(); });
      panels.forEach(function (p, k) { p.hidden = k !== i; });
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { show(k); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return; e.preventDefault(); show((k + d + tabs.length) % tabs.length, true);
      });
    });
    el._ltIngShow = function (p) { var k = panels.indexOf(p); if (k < 0) k = tabs.indexOf(p); if (k >= 0) show(k); };
    function warm() { panels.forEach(function (p) { QA('img[loading="lazy"]', p).forEach(function (im) { im.loading = 'eager'; }); }); }
    if (document.readyState === 'complete') setTimeout(warm, 1200); else window.addEventListener('load', function () { setTimeout(warm, 1200); });
  }

  function acc(el) {
    if (!once(el, 'acc')) return;
    var items = QA('details', el);
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (x) { if (x !== d && x.open) x.open = false; });
      });
    });
  }

  function init(root) {
    root = root || document;
    QA('[data-lt-slider]', root).forEach(slider);
    QA('[data-lt-gal]', root).forEach(gallery);
    QA('[data-lt-pdp]', root).forEach(packs);
    QA('[data-lt-timer]', root).forEach(timer);
    QA('[data-lt-qs]', root).forEach(quotes);
    playables(root);
    QA('[data-lt-reviews]', root).forEach(filters);
    QA('[data-lt-quizroot]', root).forEach(quiz);
    QA('[data-lt-sticky]', root).forEach(sticky);
    QA('[data-lt-header]', root).forEach(header);
    QA('[data-lt-cart]', root).forEach(cartPage);
    QA('[data-lt-ing]', root).forEach(ingTabs);
    QA('[data-lt-acc]', root).forEach(acc);
    promoInit();
    jumps(document);
    checkoutRoute();
    giftWatch();
    cardStrip();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var b = e.target;
    if (b && b.hasAttribute && b.hasAttribute('data-pk')) { var r = b.closest('[data-lt-pdp]'); if (r) b.click(); }
    var ing = b && b.closest && b.closest('[data-lt-ing]');
    if (ing && ing._ltIngShow) ing._ltIngShow(b.hasAttribute('data-ingtab') ? b : b.closest('[data-ingpanel]'));
    if (b && b.matches && b.matches('details.lt-pacc__i')) b.open = true;
  });
  window.LeetUI = { init: init };
})();
